import { createApi } from "@reduxjs/toolkit/query/react";
import { defaultBaseQuery } from "../../../utils/API/fetchBaseQuery";
import { encryptQueryString, transformRequest } from "../../../utils/API/requestMiddleware";
import { transformErrorResponse, transformSuccessResponse } from "../../../utils/API/responseMiddleware";

const MembershipPricingServiceApi = createApi({
    reducerPath: 'MembershipPricingServiceApi',
    baseQuery: defaultBaseQuery,
    endpoints: (builder) => ({
        AddEditMembershipPricing: builder.mutation({
            query: (details) => ({
                url: '/MembershipPricing/AddEditMembershipPricing',
                method: 'POST',
                body: transformRequest(details)
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        getAllMembershipPricing:builder.query({
            query:()=>({
                url:'MembershipPricing/GetAllMembershipPricing',
                method:'GET'
            }),
            transformResponse:transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        })
    }),

})

export const {
    useAddEditMembershipPricingMutation,
    useLazyGetAllMembershipPricingQuery
} = MembershipPricingServiceApi;

export default MembershipPricingServiceApi;